<footer class="footer">
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-6"> <span>© {{year}} UNT Health Fort Worth</span></div>
      <div class="col-12 col-sm-6 text-right"><a *ngIf="privacyUrl$ | async as privacyUrl" class="policy-link"  [href]="privacyUrl" target="_blank" rel="noopener noreferrer">Privacy Policy</a></div>
    </div>
  </div>
</footer>